import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';

export type  AlertType= ''|'info'|'success'|'warning'|'danger'|'rose'|'primary';
export interface Alert {
    type: AlertType
    message:string
    from:any
    align:any
}
export interface AlertMess {
    message:string
}
@Injectable()
export class AlertService {
    public alert$ = new Subject<Alert>()

    info(message:string){
        this.alert$.next({
            type: 'info',
            message: message,
            from: 'top',
            align: 'left'})
    }

    warning(message:string){
        this.alert$.next({
            type: 'warning',
            message: message,
            from: 'top',
            align: 'left'})
    }
    success(message:string){
        this.alert$.next({
            type: 'success',
            message: message,
            from: 'top',
            align: 'left'})
    }
    danger(message:string){
        this.alert$.next({
            type: 'danger',
            message: message,
            from: 'top',
            align: 'left'})
    }
    rose(message:string){
        this.alert$.next({
            type: 'rose',
            message: message,
            from: 'top',
            align: 'left'})
    }
    primary(message:string){
        this.alert$.next({
            type: 'primary',
            message: message,
            from: 'top',
            align: 'left'})
    }


}
